module.exports = __webpack_public_path__ + "static/img/icon_kckp.74367740.png";